import React from 'react';

import Button, { ButtonProps } from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { ReactComponent as ScanIcon } from '../../../common/assets/icons/scan_icon.svg';

type Props = {
  title: string;
};

const ScanButton: React.FC<ButtonProps & Props> = (props) => {
  return (
    <Button
      {...props}
      disableElevation
      variant='contained'
      color='primary'
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        px: '25px',
        display: 'flex',
        height: '50px',
        borderRadius: '15px',
      }}
    >
      <ScanIcon />
      <Typography color='white'>{props.title}</Typography>
    </Button>
  );
};

export default ScanButton;
